import type {
  AwardCountLimitPeriodOption,
  AwardCountLimitTimePeriod,
} from './award-count-limit.types';

export const AWARD_COUNT_LIMIT_MAX_ROWS = 4;

export const awardCountPeriodOptions: AwardCountLimitPeriodOption[] = [
  { label: 'Daily', value: 'DAY' },
  { label: 'Weekly', value: 'WEEK' },
  { label: 'Monthly', value: 'MONTH' },
  { label: 'Total', value: 'TOTAL' },
];

export const awardCountPeriodOptionsExcludingTotal: {
  label: string;
  value: Exclude<AwardCountLimitTimePeriod, 'TOTAL'>;
}[] = [
  { label: 'Daily', value: 'DAY' },
  { label: 'Weekly', value: 'WEEK' },
  { label: 'Monthly', value: 'MONTH' },
];
